(function () {
  if (window.__shopLocallyGuideInit) return;
  window.__shopLocallyGuideInit = true;

  var DISMISS_PREFIX = "robam_store_guide_dismiss_";
  var DISMISS_DAYS = 14;
  var MS_PER_DAY = 24 * 60 * 60 * 1000;

  function parseData() {
    var node = document.getElementById("ShopLocallyGuideData");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function findStore(data) {
    var params = new URLSearchParams(window.location.search);
    var country = String(
      params.get("shop_locally") || data.visitorCountry || ""
    ).toUpperCase();
    if (!country || !Array.isArray(data.stores)) return null;
    return data.stores.find(function (store) {
      return String(store.code || "").toUpperCase() === country;
    }) || null;
  }

  function isDismissed(code, designMode) {
    if (designMode) return false;
    try {
      var raw = localStorage.getItem(DISMISS_PREFIX + code);
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      if (isNaN(ts)) return false;
      return Date.now() - ts < DISMISS_DAYS * MS_PER_DAY;
    } catch (e) {
      return false;
    }
  }

  function setDismissed(code, designMode) {
    if (designMode) return;
    try {
      localStorage.setItem(DISMISS_PREFIX + code, String(Date.now()));
    } catch (e) {}
  }

  function replaceToken(text, token, value) {
    return String(text || "").split(token).join(value || "");
  }

  function decodeEntities(text) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = String(text || "");
    return textarea.value;
  }

  function storeHost(url) {
    return String(url || "")
      .replace(/^https?:\/\//, "")
      .split("/")[0];
  }

  function storeHref(url, code) {
    var utm =
      "utm_source=robamworld&utm_medium=geo_guide&utm_campaign=" +
      String(code || "").toLowerCase() +
      "_store";
    return String(url || "").indexOf("?") === -1 ? url + "?" + utm : url + "&" + utm;
  }

  function fillGuide(guide, data, store) {
    var strings = data.strings || {};
    var host = storeHost(store.url);
    var map = function (value) {
      return decodeEntities(
        replaceToken(replaceToken(value, "__STORE__", store.label), "__HOST__", host)
      );
    };

    var eyebrow = guide.querySelector("[data-shop-locally-eyebrow]");
    var title = guide.querySelector("[data-shop-locally-title]");
    var text = guide.querySelector("[data-shop-locally-text]");
    var go = guide.querySelector("[data-shop-locally-go]");
    var stay = guide.querySelector("[data-shop-locally-stay]");

    if (eyebrow) eyebrow.textContent = map(strings.eyebrow);
    if (title) title.textContent = map(strings.title);
    if (text) text.textContent = map(strings.text);
    if (go) {
      go.textContent = map(strings.continue);
      go.setAttribute("href", storeHref(store.url, store.code));
    }
    if (stay) stay.textContent = decodeEntities(strings.stay || "Stay on this site");
  }

  function openGuide(guide) {
    guide.hidden = false;
    guide.removeAttribute("hidden");
    guide.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    var dialog = guide.querySelector("[data-shop-locally-dialog]");
    if (dialog) {
      try {
        dialog.focus();
      } catch (e) {}
    }
  }

  function closeGuide(guide, persist, code, designMode) {
    if (persist) setDismissed(code, designMode);
    guide.hidden = true;
    guide.setAttribute("hidden", "");
    guide.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function init() {
    var data = parseData();
    var guide = document.getElementById("ShopLocallyGuide");
    if (!data || !guide) return;

    var store = findStore(data);
    if (!store) return;
    if (isDismissed(store.code, data.designMode)) return;

    fillGuide(guide, data, store);

    if (guide.parentElement !== document.body) {
      document.body.appendChild(guide);
    }

    guide.querySelectorAll("[data-shop-locally-dismiss]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var persist = btn.hasAttribute("data-shop-locally-stay");
        closeGuide(guide, persist, store.code, data.designMode);
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !guide.hidden) {
        closeGuide(guide, false, store.code, data.designMode);
      }
    });

    setTimeout(function () {
      if (!isDismissed(store.code, data.designMode)) openGuide(guide);
    }, 400);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
